const AZURE_RESOURCE_TYPES = {
  // L4: 'cad854db-c733-4449-b109-a59e258a5e6e',
  // V100: '4daa38b5-df6f-47ae-b70e-6c16315aca0e',
  // T4: 'c735ed24-41af-41e7-94b6-57215768f068',
  // A100: 'd99bf4f7-92b7-4622-9355-a7aa3f5469b5',
  H100: 'da6aca1e-946c-4ff4-8283-e4ff592bf581',
  MI300X: '990bebce-1cc2-4a12-936d-62b281cdfcdd',
  CPU: '78201a90-ca48-4147-b6f5-fec51b4bd7db',
};
export default AZURE_RESOURCE_TYPES;
